import {
  datepicker,
  formBuilder,
  ListCustomizer,
} from '@kinet-open-network/client/core/forms/ui';
import { CustomerInvoicesTabComponent } from '@kinet-open-network/client/customers/feature/detail';
import { Invoice } from '@kinet-open-network/client/invoices/data-access';
import {
  confirmDialog,
  TableConfig,
} from '@kinet-open-network/client/shared/ui';
import { automationActionTypeOptions } from '@kinet-open-network/shared/data-access/model';
import { IAutomationActionGenerateCustomerRentalInvoiceData } from '@kinet-open-network/shared/data-access/model-pbgas';

export const customerInvoicesListCustomization: ListCustomizer<
  Invoice,
  CustomerInvoicesTabComponent
> = (context) => {
  const ability = context.ability();
  const store = context.store;
  const options = automationActionTypeOptions.get(
    'generate-customer-rental-invoice',
  );

  const config: TableConfig<Invoice> = {
    stateKey: 'customer-invoices',
    header: {
      newButton: ability.can('create', 'Invoice')
        ? {
            label: 'Pridať',
            routerLink: ['create'],
            queryParams: { customerId: context.customerId() },
            icon: 'pi pi-plus',
          }
        : false,
      actions: [
        {
          label: 'Exportovať',
          icon: 'pi pi-download',
          command: () => store.export(),
          disabled: ability?.cannot('export', 'Invoice'),
        },
        {
          label: 'Hromadné akcie',
          icon: 'pi pi-cog',
          command: () => context.batchActionsVisible.set(true),
          disabled: ability?.cannot('update', 'Invoice'),
        },
        ...(ability.can('create', 'Invoice')
          ? [
              {
                label: options?.label,
                icon: options?.icon,
                command: () =>
                  confirmDialog({
                    header: options?.label,
                    form: {
                      model: { date: new Date() },
                      fields: formBuilder([
                        datepicker('date', 'Obdobie').view('month').required(),
                      ]),
                      onSubmit: (
                        model: IAutomationActionGenerateCustomerRentalInvoiceData,
                      ) =>
                        context.automationsStore
                          .runAction(
                            'generate-customer-rental-invoice',
                            'customer',
                            { customerId: context.customerId() },
                            { date: model.date },
                          )
                          .then(() => store.refreshPaginated()),
                    },
                  }),
              },
            ]
          : []),
      ],
    },
    actions: [
      {
        label: 'Detail',
        icon: 'pi pi-eye',
        routerLink: (invoice) => [invoice.id],
        context: ['row', 'menu', 'contextMenu'],
        visible: (invoice) =>
          ability?.can('read', invoice) && ability?.cannot('update', invoice),
      },
      {
        label: 'Upraviť',
        icon: 'pi pi-pencil',
        routerLink: (invoice) => [invoice.id, 'edit'],
        context: 'all',
        visible: (invoice) => ability?.can('update', invoice),
      },
      {
        label: 'Kopírovať',
        icon: 'pi pi-copy',
        routerLink: () => ['create'],
        queryParams: (invoice) => ({ copy: invoice?.id }),
        context: ['row', 'menu', 'contextMenu'],
        visible: (invoice) => ability?.can('create', invoice),
      },
      {
        label: 'Vymazať',
        icon: 'pi pi-trash',
        context: ['menu', 'contextMenu'],
        visible: (invoice) => ability?.can('delete', invoice),
        command: (invoice) => context.delete(invoice),
      },
      {
        label: 'Audit',
        icon: 'pi pi-history',
        routerLink: (invoice) => [invoice.id, 'audits'],
        context: ['menu', 'contextMenu'],
        visible: (invoice) => ability?.can('read', invoice),
      },
    ],
  };

  return { config };
};
